import { render, staticRenderFns } from "./BfBank.vue?vue&type=template&id=0cd7926c&scoped=true"
import script from "./BfBank.vue?vue&type=script&lang=js"
export * from "./BfBank.vue?vue&type=script&lang=js"
import style0 from "./BfBank.vue?vue&type=style&index=0&id=0cd7926c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd7926c",
  null
  
)

export default component.exports